import { useEffect, useRef, useState } from "react";
import { environment } from "../../app/environment";
import { getTheme, Themes } from "./ThemeSelector";

const { lightMode, darkMode, alt } = environment.instanceConfig;

const preloadImages = () => {
  const imgDark = new Image();
  imgDark.src = darkMode;

  const imgLight = new Image();
  imgLight.src = lightMode;
};

preloadImages();

export function DynamicLogo() {
  const [theme, setTheme] = useState(getTheme());
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const handleThemeChange = () => setTheme(getTheme());
    window.addEventListener("themeChange", handleThemeChange);
    if (imgRef.current) {
      imgRef.current.src = theme === Themes.dark ? darkMode : lightMode;
    }
    return () => window.removeEventListener("themeChange", handleThemeChange);
  }, [theme]);

  return (
    <img
      ref={imgRef}
      src={theme === Themes.dark ? darkMode : lightMode}
      className="h-[24px] w-[120px]"
      alt={alt}
    />
  );
}
